module.exports = __webpack_public_path__ + "img/bm4.2426aa98.png";